import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PhotoUploadService } from '../components/camera/camera/photo-upload.service';
import { HttpRequestCustomHeaderNames, HttpRequestCustomHeaderValues } from '../models/common.enums';
import {
    IPhotoUpload,
    IUploadUrlRequest,
    IUploadUrlResponse,
    PhotoData
} from '@ui-app/models/common.models';

@Injectable()
export class S3PhotoUploadService extends PhotoUploadService implements IPhotoUpload {
    constructor(
        private httpClient: HttpClient,
    ) {
        super();
    }

    private getS3UploadInfo(request: IUploadUrlRequest, uploadUrl: string): Observable<IUploadUrlResponse> {
        return this.httpClient.post<IUploadUrlResponse>(uploadUrl, request);
    }

    private uploadS3File(url: string, arrayBuffer: ArrayBuffer | string, headers: HttpHeaders): Observable<null> {
        return this.httpClient.put<null>(url, arrayBuffer, { headers });
    }

    uploadPhoto(request: IUploadUrlRequest, uploadUrl: string, dataUrl: string): Observable<PhotoData> {
        let fileGuid: string;
        const { arrayBuffer, length }: {
            arrayBuffer: ArrayBuffer | string;
            length: number;
        } = this.base64ToArrayBuffer(dataUrl);
        request.length = length;

        return this.getS3UploadInfo(request, uploadUrl)
            .pipe(
                switchMap((uploadInfo: IUploadUrlResponse) => {
                    const { url, uId, headersToSet } = uploadInfo;
                    fileGuid = uId;
                    const headers: HttpHeaders = new HttpHeaders({
                        'Content-Type': request.contentType,
                        [HttpRequestCustomHeaderNames.DisableLoader]: HttpRequestCustomHeaderValues.LoaderDisabled,
                        ...headersToSet
                    });
                    return this.uploadS3File(url, arrayBuffer, headers);
                }),
                map(() => ({ uId: fileGuid, ...request })),
            );
    }
}
